import { render, staticRenderFns } from "./ChatPollV2.vue?vue&type=template&id=c5a28cba&scoped=true"
import script from "./ChatPollV2.vue?vue&type=script&lang=js"
export * from "./ChatPollV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a28cba",
  null
  
)

export default component.exports